import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  SellingTerminalInterface,
  SellingTerminalsResumeInterface,
  SellingTerminalsTypes,
  SellingTerminalResumeInterface,
  SellingTerminalsDailyReportInterface,
  SellingShiftInterface,
  SellingTerminalWalletHistoryInterface,
  SellingTerminalWalletBalanceInterface,
  TicketCountListInterface,
  ShiftScheduleListInterface,
  SellingTerminalPaymentRequestInterface,
} from './types';

// List Selling Terminals
export const listSellingTerminalsRequest = (payload: {
  body?: object;
  filtering?: boolean;
  notOperatorId?: boolean;
}) =>
  asyncAction(SellingTerminalsTypes.LIST_SELLING_TERMINALS_REQUEST, payload);
export const listSellingTerminalsSuccess = (payload: {
  sellingTerminalsList: SellingTerminalInterface[];
  totalCount: number;
}) => action(SellingTerminalsTypes.LIST_SELLING_TERMINALS_SUCCESS, payload);
export const listSellingTerminalsFailure = () =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINALS_FAILURE);

// Get Selling Terminal
export const getSellingTerminalRequest = (payload: object) =>
  asyncAction(SellingTerminalsTypes.GET_SELLING_TERMINAL_REQUEST, payload);
export const getSellingTerminalSuccess = (payload: {
  sellingTerminalData: SellingTerminalInterface;
}) => action(SellingTerminalsTypes.GET_SELLING_TERMINAL_SUCCESS, payload);
export const getSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.GET_SELLING_TERMINAL_FAILURE);

// Get Daily Selling Terminal
export const getDailySellingTerminalRequest = (payload: object) =>
  action(SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_REQUEST, payload);
export const getDailySellingTerminalSuccess = (payload: {
  sellingTerminalsDailyReports: SellingTerminalsDailyReportInterface[];
}) => action(SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_SUCCESS, payload);
export const getDailySellingTerminalFailure = () =>
  action(SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_FAILURE);

// Filter Selling Terminals
export const filterSellingTerminalsRequest = (payload: object) =>
  asyncAction(SellingTerminalsTypes.FILTER_SELLING_TERMINALS_REQUEST, payload);
export const filterSellingTerminalsSuccess = (payload: {
  sellingTerminalsList: SellingTerminalInterface[];
  totalCount: number;
}) => action(SellingTerminalsTypes.FILTER_SELLING_TERMINALS_SUCCESS, payload);
export const filterSellingTerminalsFailure = () =>
  action(SellingTerminalsTypes.FILTER_SELLING_TERMINALS_FAILURE);

// Create Selling Terminal
export const createSellingTerminalRequest = (payload: object) =>
  action(SellingTerminalsTypes.CREATE_SELLING_TERMINAL_REQUEST, payload);
export const createSellingTerminalSuccess = (payload: {
  sellingTerminalData: SellingTerminalInterface;
}) => action(SellingTerminalsTypes.CREATE_SELLING_TERMINAL_SUCCESS, payload);
export const createSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.CREATE_SELLING_TERMINAL_FAILURE);

// Update Selling Terminal
export const updateSellingTerminalRequest = (payload: {
  body: object;
  isSellingTerminal?: boolean;
}) => action(SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_REQUEST, payload);
export const updateSellingTerminalSuccess = (payload: {
  sellingTerminalData: SellingTerminalInterface;
}) => action(SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_SUCCESS, payload);
export const updateSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_FAILURE);

// Delete Selling Terminal
export const deleteSellingTerminalRequest = (payload: object) =>
  action(SellingTerminalsTypes.DELETE_SELLING_TERMINAL_REQUEST, payload);
export const deleteSellingTerminalSuccess = () =>
  action(SellingTerminalsTypes.DELETE_SELLING_TERMINAL_SUCCESS);
export const deleteSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.DELETE_SELLING_TERMINAL_FAILURE);

// Add Payment Selling Terminal
export const addPaymentSellingTerminalRequest = (payload: object) =>
  asyncAction(
    SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_REQUEST,
    payload,
  );
export const addPaymentSellingTerminalSuccess = () =>
  action(SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_SUCCESS);
export const addPaymentSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_FAILURE);

// Add Pre Paid Payment Selling Terminal
export const addPrePaidPaymentSellingTerminalRequest = (payload: object) =>
  asyncAction(
    SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_REQUEST,
    payload,
  );
export const addPrePaidPaymentSellingTerminalSuccess = () =>
  action(SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_SUCCESS);
export const addPrePaidPaymentSellingTerminalFailure = () =>
  action(SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_FAILURE);

// Change Selling Terminal Status
export const changeSellingTerminalStatusRequest = (
  sellingTerminalData: SellingTerminalInterface,
  newStatus: number,
) =>
  action(SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_REQUEST, {
    sellingTerminalData,
    newStatus,
  });
export const changeSellingTerminalStatusSuccess = () =>
  action(SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_SUCCESS);
export const changeSellingTerminalStatusFailure = () =>
  action(SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_FAILURE);

// List Payments
export const listPaymentsRequest = (payload: any) =>
  action(SellingTerminalsTypes.LIST_PAYMENTS_REQUEST, payload);
export const listPaymentsSuccess = (payload: { paymentsList: any[] }) =>
  action(SellingTerminalsTypes.LIST_PAYMENTS_SUCCESS, payload);
export const listPaymentsFailure = () =>
  action(SellingTerminalsTypes.LIST_PAYMENTS_FAILURE);

// List wallet histories
export const listSellingTerminalWalletHistoriesRequest = (payload: {
  body: object;
  notOperatorId?: boolean;
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_REQUEST,
    payload,
  );
export const listSellingTerminalWalletHistoriesSuccess = (payload: {
  sellingTerminalWalletHistories: SellingTerminalWalletHistoryInterface[];
  totalCount: number;
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_SUCCESS,
    payload,
  );
export const listSellingTerminalWalletHistoriesFailure = () =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_FAILURE);

// List wallet balances
export const listSellingTerminalWalletBalancesRequest = (payload: {
  body: object;
  notOperatorId?: boolean;
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_REQUEST,
    payload,
  );
export const listSellingTerminalWalletBalancesSuccess = (payload: {
  sellingTerminalWalletBalances: SellingTerminalWalletBalanceInterface[];
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_SUCCESS,
    payload,
  );
export const listSellingTerminalWalletBalancesFailure = () =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_FAILURE);

// List Transactions
export const listTransactionsRequest = (payload: any) =>
  action(SellingTerminalsTypes.LIST_TRANSACTIONS_REQUEST, payload);
export const listTransactionsSuccess = (payload: { transactionsList: any[] }) =>
  action(SellingTerminalsTypes.LIST_TRANSACTIONS_SUCCESS, payload);
export const listTransactionsFailure = () =>
  action(SellingTerminalsTypes.LIST_TRANSACTIONS_FAILURE);

// Get Selling Terminals Resume
export const getSellingTerminalsResumeRequest = (payload: object) =>
  asyncAction(
    SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_REQUEST,
    payload,
  );
export const getSellingTerminalsResumeSuccess = (payload: {
  sellingTerminalsResume: SellingTerminalsResumeInterface;
}) =>
  action(SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_SUCCESS, payload);
export const getSellingTerminalsResumeFailure = () =>
  action(SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_FAILURE);

// Get Selling Reports Resume
export const getSellingReportsResumeRequest = (payload: object) =>
  asyncAction(
    SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_REQUEST,
    payload,
  );

export const getSellingReportsResumeSuccess = (payload: {
  sellingReportsResume: SellingTerminalsResumeInterface;
}) => action(SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_SUCCESS, payload);

export const getSellingReportsResumeFailure = () =>
  action(SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_FAILURE);

// List Transactions Resume
export const listTransactionsResumeRequest = (payload: object) =>
  action(SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_REQUEST, payload);
export const listTransactionsResumeSuccess = (payload: {
  sellingTerminalsResumeList: SellingTerminalResumeInterface[];
}) => action(SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_SUCCESS, payload);
export const listTransactionsResumeFailure = () =>
  action(SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_FAILURE);

// Selling Terminal Pay Boleto
export const sellingTerminalPayBoletoRequest = (payload: {
  attachment: File[];
}) =>
  action(SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_REQUEST, payload);
export const sellingTerminalPayBoletoSuccess = () =>
  action(SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_SUCCESS);
export const sellingTerminalPayBoletoFailure = () =>
  action(SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_FAILURE);

// Selected Credit Type
export const setSelectedReceivingType = (payload: {
  selectedReceivingType?: number;
}) => action(SellingTerminalsTypes.SET_SELECTED_RECEIVING_TYPE, payload);

// List Selling Shift
export const listSellingShiftsRequest = (payload: object) =>
  action(SellingTerminalsTypes.LIST_SELLING_SHIFT_REQUEST, payload);
export const listSellingShiftsSuccess = (payload: {
  sellingShiftList: SellingShiftInterface[];
}) => action(SellingTerminalsTypes.LIST_SELLING_SHIFT_SUCCESS, payload);
export const listSellingShiftsFailure = () =>
  action(SellingTerminalsTypes.LIST_SELLING_SHIFT_FAILURE);

// List Selling Shift
export const listSellingTerminalCashierRequest = (payload: {
  body: object;
  noShowLoading?: boolean;
}) =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_REQUEST, payload);
export const listSellingTerminalCashierSuccess = (payload: {
  sellingTerminalCashierList: any[];
}) =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_SUCCESS, payload);
export const listSellingTerminalCashierFailure = () =>
  action(SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_FAILURE);

// List TicketCount
export const listTicketCountRequest = (payload: object) =>
  action(SellingTerminalsTypes.LIST_TICKET_COUNT_REQUEST, payload);
export const listTicketCountSuccess = (payload: {
  ticketCountList: TicketCountListInterface[];
}) => action(SellingTerminalsTypes.LIST_TICKET_COUNT_SUCCESS, payload);
export const listTicketCountFailure = () =>
  action(SellingTerminalsTypes.LIST_TICKET_COUNT_FAILURE);

// Create TicketCount
export const createTicketCountRequest = (payload: object) =>
  action(SellingTerminalsTypes.CREATE_TICKET_COUNT_REQUEST, payload);
export const createTicketCountSuccess = () =>
  action(SellingTerminalsTypes.CREATE_TICKET_COUNT_SUCCESS);
export const createTicketCountFailure = () =>
  action(SellingTerminalsTypes.CREATE_TICKET_COUNT_FAILURE);

// Update TicketCount
export const updateTicketCountRequest = (payload: object) =>
  action(SellingTerminalsTypes.UPDATE_TICKET_COUNT_REQUEST, payload);
export const updateTicketCountSuccess = () =>
  action(SellingTerminalsTypes.UPDATE_TICKET_COUNT_SUCCESS);
export const updateTicketCountFailure = () =>
  action(SellingTerminalsTypes.UPDATE_TICKET_COUNT_FAILURE);

// Delete TicketCount
export const deleteTicketCountRequest = (payload: object) =>
  action(SellingTerminalsTypes.DELETE_TICKET_COUNT_REQUEST, payload);
export const deleteTicketCountSuccess = () =>
  action(SellingTerminalsTypes.DELETE_TICKET_COUNT_SUCCESS);
export const deleteTicketCountFailure = () =>
  action(SellingTerminalsTypes.DELETE_TICKET_COUNT_FAILURE);

// Shift Schedule List
export const listShiftScheduleRequest = (payload: object) =>
  action(SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_REQUEST, payload);
export const listShiftScheduleSuccess = (payload: {
  shiftScheduleList: ShiftScheduleListInterface[];
}) => action(SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_SUCCESS, payload);
export const listShiftScheduleFailure = () =>
  action(SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_FAILURE);

// Create ShiftSchedule
export const createShiftScheduleRequest = (payload: object) =>
  asyncAction(SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_REQUEST, payload);
export const createShiftScheduleSuccess = () =>
  action(SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_SUCCESS);
export const createShiftScheduleFailure = () =>
  action(SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_FAILURE);

// Update ShiftSchedule
export const updateShiftScheduleRequest = (payload: object) =>
  asyncAction(SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_REQUEST, payload);
export const updateShiftScheduleSuccess = () =>
  action(SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_SUCCESS);
export const updateShiftScheduleFailure = () =>
  action(SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_FAILURE);

// Delete ShiftSchedule
export const deleteShiftScheduleRequest = (payload: object) =>
  asyncAction(SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_REQUEST, payload);
export const deleteShiftScheduleSuccess = () =>
  action(SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_SUCCESS);
export const deleteShiftScheduleFailure = () =>
  action(SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_FAILURE);

// Shift Schedule Run
export const shiftScheduleRunRequest = (payload: object) =>
  action(SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_REQUEST, payload);
export const shiftScheduleRunSuccess = () =>
  action(SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_SUCCESS);
export const shiftScheduleRunFailure = () =>
  action(SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_FAILURE);

// List Selling Terminal Payment Requests (Faturas)
export const listSellingTerminalPaymentRequestsRequest = (payload: {
  sellingTerminalId: string;
  _page?: number;
  _limit?: number;
  _order?: 'ASC' | 'DESC';
  _sort?: string;
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_REQUEST,
    payload,
  );
export const listSellingTerminalPaymentRequestsSuccess = (payload: {
  sellingTerminalPaymentRequestsList: SellingTerminalPaymentRequestInterface[];
}) =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_SUCCESS,
    payload,
  );
export const listSellingTerminalPaymentRequestsFailure = () =>
  action(
    SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_FAILURE,
  );

// Cancel Selling Terminal Payment Request (Fatura)
export const cancelSellingTerminalPaymentRequestRequest = (payload: {
  sellingTerminalPaymentRequestId: string;
  sellingTerminalId: string;
  _page?: number;
  _limit?: number;
}) =>
  action(
    SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_REQUEST,
    payload,
  );
export const cancelSellingTerminalPaymentRequestSuccess = () =>
  action(
    SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_SUCCESS,
  );
export const cancelSellingTerminalPaymentRequestFailure = () =>
  action(
    SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_FAILURE,
  );
